module.exports = __webpack_public_path__ + "img/formules.af33ccaa.jpg";